"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDashboard = function IconDashboard(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.2 11.8V20.2H11.8V11.8H20.2ZM21 9H11C10.4696 9 9.96086 9.21071 9.58579 9.58579C9.21071 9.96086 9 10.4696 9 11V21C9 21.5304 9.21071 22.0391 9.58579 22.4142C9.96086 22.7893 10.4696 23 11 23H21C21.5304 23 22.0391 22.7893 22.4142 22.4142C22.7893 22.0391 23 21.5304 23 21V11C23 10.4696 22.7893 9.96086 22.4142 9.58579C22.0391 9.21071 21.5304 9 21 9Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.2 11.8V20.2H29.8V11.8H38.2ZM39 9H29C28.4696 9 27.9609 9.21071 27.5858 9.58579C27.2107 9.96086 27 10.4696 27 11V21C27 21.5304 27.2107 22.0391 27.5858 22.4142C27.9609 22.7893 28.4696 23 29 23H39C39.5304 23 40.0391 22.7893 40.4142 22.4142C40.7893 22.0391 41 21.5304 41 21V11C41 10.4696 40.7893 9.96086 40.4142 9.58579C40.0391 9.21071 39.5304 9 39 9Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.2 29.8V38.2H11.8V29.8H20.2ZM21 27H11C10.4696 27 9.96086 27.2107 9.58579 27.5858C9.21071 27.9609 9 28.4696 9 29V39C9 39.5304 9.21071 40.0391 9.58579 40.4142C9.96086 40.7893 10.4696 41 11 41H21C21.5304 41 22.0391 40.7893 22.4142 40.4142C22.7893 40.0391 23 39.5304 23 39V29C23 28.4696 22.7893 27.9609 22.4142 27.5858C22.0391 27.2107 21.5304 27 21 27Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39 27H29C28.4696 27 27.9609 27.2107 27.5858 27.5858C27.2107 27.9609 27 28.4696 27 29V39C27 39.5304 27.2107 40.0391 27.5858 40.4142C27.9609 40.7893 28.4696 41 29 41H39C39.5304 41 40.0391 40.7893 40.4142 40.4142C40.7893 40.0391 41 39.5304 41 39V29C41 28.4696 40.7893 27.9609 40.4142 27.5858C40.0391 27.2107 39.5304 27 39 27Z",
    fill: color
  }));
};

IconDashboard.defaultProps = {
  color: 'black',
  size: 30
};
IconDashboard.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconDashboard;
exports.default = _default;